import { styled } from 'stitches.config'

export const WhatYouNeedRoot = styled('section', {
  width: '100%',
  margin: 'auto',
  paddingBottom: '$6',
  '@bp2': {
    padding: '$7 0 $8'
  }
})

export const Header = styled('h2', {
  fontSize: '$h3',
  width: '100%',
  textAlign: 'center',
  marginBottom: '$6',
  display: 'none',
  padding: '0 $2',

  '&.m-only': {
    display: 'block',
    maxWidth: '440px',
    marginTop: '$3',
    marginBottom: '$4',
  },

  '@bp2': {
    fontSize: '$h1',
    display: 'block',
    '&.m-only': {
      display: 'none',
    },
  },
})

export const WhatYouNeedBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  margin: 'auto',
  maxWidth: '500px',
  '@bp2': {
    maxWidth: '1800px',
    flexDirection: 'row',
    alignItems: 'center',
  },
})

export const ImageColumn = styled('div', {
  width: '100%',
  '@bp2': {
    width: '50.7%',
  },
})

export const FeatureColumn = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  padding: '0 $2',
  maxWidth: '400px',
  '@bp2': {
    width: '49.3%',
    padding: '$3',
    gap: '$1',
    maxWidth: 'none',
  },
  '@bp3': {
    padding: '$5',
    gap: '$2',
  },
})

export const Feature = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$1',
})

export const ImageWrapper = styled('div', {
  aspectRatio: '1.69/1',
  position: 'relative',
  width: '100%',
})

export const ButtonWrapper = styled('div', {
  width: '100%',
  textAlign: 'center',
  marginTop: '$5',
})

export const Subheader = styled('h3', {
  fontSize: '$h3',
  textAlign: 'center',
  marginTop: '$3',
  '@bp2': {
    fontSize: '$h2',
    textAlign: 'left',
    margin: '0',
  }
})